import { FC } from 'react';

import { Header } from '@/components';
import { useHomeRules } from '@/hooks/use-home-rules';
import { FeatureList, Footer, MainActions } from '@/pages';

import { Main } from './styled';

export const Home: FC = () => {
  const { handleClickRegisterTrucker, handleClickTalkWithASpecialist } = useHomeRules();

  return (
    <>
      <Header title="Gerenciamento de Risco Fretebras" />
      <Main>
        <MainActions
          onClickRegisterTrucker={handleClickRegisterTrucker}
          onClickTalkWithASpecialist={handleClickTalkWithASpecialist}
        />
        <FeatureList />
      </Main>
      <Footer />
    </>
  );
};
